import { FieldStringOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation';
import React from 'react';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference';
import {
  CustomWarningsRule,
  LengthRangeRule,
  RequiredRule,
  TextFormatRule,
} from '../../../../rules/repository';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { createCommonFormSchema } from '../common/createCommonFormSchema';
import { ITextWidget } from './ITextWidget';
import { TextWidgetComponent } from './TextWidgetComponent';
import {
  TextInputConfigComponent,
  TextWidgetConfigSchema,
} from './TextWidgetConfigComponent';

/**
 * Tipo del componente di input di testo.
 */
export const TextWidgetType: IWidgetType<ITextWidget> = {
  type: WidgetType.Text,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo di testo',
  icon: <FieldStringOutlined />,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.String),
  formComponent: TextWidgetComponent,
  createFormSchema: ({ widget }) =>
    createCommonFormSchema(yup.string(), widget),
  previewComponent: TextWidgetComponent,
  configValidator: TextWidgetConfigSchema,
  configComponent: TextInputConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [RequiredRule, LengthRangeRule, TextFormatRule, CustomWarningsRule],
};
